import React from "react";
import * as styles from "components/WebQuoteModal/WebQuoteModal.module.scss";
import { Icon } from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";
import { ModalFooterCta } from "components/WebQuoteModal/ModalFooterCta/ModalFooterCta";

type ErrorModalStepProps = {
  onRequestClose: () => void;
  fycRedirectUrl?: string;
};
export const ErrorModalStep: React.FC<ErrorModalStepProps> = ({
  onRequestClose,
  fycRedirectUrl
}) => {
  return (
    <>
      <div className={styles.subscriptionFailedMessage}>
        <Icon padding="inline" name="alert" size="2x" />
        <Trans>Subscription not confirmed</Trans>
      </div>
      <div className={styles.feedbackMessageContainer}>
        <div className={styles.feedbackTitle}>
          <Trans>Service temporarily unavailable</Trans>
        </div>
        <Trans>
          We sincerely apologise but we are unable to process your request at
          present. Please try again later, or contact our Reservation Team for
          assistance.
        </Trans>
      </div>
      <div className={styles.feedbackFooterContainer}>
        <div className={styles.needAssistance}>
          <Trans>
            Need assistance? Call our Reservation Team +1-888-978-4070
          </Trans>
        </div>

        <div className={styles.needAssistanceHours}>
          <Trans>
            Mon – Fri: 09:00 – 20:00 EST; Sat: 09:00 – 17:00 EST; Sun: Closed
          </Trans>
        </div>
      </div>

      <ModalFooterCta
        fycRedirectUrl={fycRedirectUrl}
        onRequestClose={onRequestClose}
      />
    </>
  );
};
